// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light polish of the access forms (login, password reset/request, account creation) that keeps
 * their original layout: outlined fields like the other forms, more breathing room
 * and clearer buttons. Use it with @include auth-polish.form; at the END of the form
 * stylesheet, so it wins over the older rules. */
/* Page around the forms: slightly narrower column and a more compact logo */
ion-checkbox {
  margin-left: 0;
}

ion-button {
  width: 100%;
}

.iconTab {
  height: 15px;
  font-size: 16px;
  transform: scale(2);
}

.centerCol {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

ion-checkbox {
  margin-right: 15px;
}

/* Consents: checkbox aligned with the first line of its text */
ion-item:has(.label-term-of-condition) {
  --padding-start: 0;
  --inner-padding-end: 0;
  --background: transparent;
  --min-height: 0;
  margin-top: 10px;
}
ion-item:has(.label-term-of-condition) ion-checkbox {
  align-self: flex-start;
  margin: 2px 12px 0 0;
}

.label-term-of-condition {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  white-space: normal;
  color: var(--ion-color-medium-shade);
}

.item-remember-me {
  margin-top: 9px;
}

.item-auto-access {
  margin-bottom: 9px;
}

.checkbox-in-list,
.checkbox-label {
  margin-top: 0;
  margin-bottom: 0;
}

.item-checkbox {
  --ripple-color: transparent;
  --background-hover: var(--background);
  --min-height: 35px;
}

.button-login {
  --box-shadow: none;
  --border-radius: 10px;
  font-size: 17px;
}

.button-account {
  --box-shadow: none;
  --background: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary) !important;
}

.divRole {
  background-color: var(--ion-color-primary);
  color: white;
  width: 100%;
  border-radius: 10px;
  cursor: hand;
  cursor: pointer;
  border: 2px solid var(--ion-color-primary);
}
.divRole ion-icon {
  color: white;
}

.divRoleNotSelected {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  cursor: hand;
  cursor: pointer;
}

.gridRole {
  padding: 15px 15px;
}

ion-icon {
  color: var(--ion-color-primary);
}

.roleItem {
  margin-top: 5px;
  /* Role cards as wide as the fields below */
  --padding-start: 0;
  --inner-padding-end: 0;
}

/* Space between the role cards and the first field */
.roleItem + ion-input {
  margin-top: 22px;
}

.labelRole {
  margin-left: 5px;
}

.labelDescription {
  font-size: 10px;
  margin-left: 5px;
}

.label-floating-login {
  margin-left: 5px;
  margin-right: 5px;
}

.button-go-back {
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
  color: var(--ion-color-primary);
  font-size: 17px;
}

/* Links to the privacy policy / conditions */
a {
  color: var(--ion-color-primary);
  font-weight: 600;
  cursor: pointer;
}
a:hover {
  color: var(--ion-color-primary-shade);
}

/* Light polish keeping the original look (kept last so it wins over the rules above) */
/* Fields: outlined and rounded like the other forms, primary ring when focused */
ion-input[fill=outline],
ion-select[fill=outline] {
  --border-radius: 10px;
  --border-color: rgba(var(--ion-color-medium-rgb), 0.4);
  --highlight-color-focused: var(--ion-color-primary);
  --background: var(--ion-background-color, #fff);
  min-height: 56px;
  margin-bottom: 14px;
}

/* Title / description of the forms */
.titleLbl {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
}

.descriptionlbl {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  color: var(--ion-color-medium-shade);
}

/* "Forgot password?": on the right, under the password */
ion-item:has(.label-forgot-password) {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  margin-top: -6px;
  text-align: right;
}

.label-forgot-password {
  font-size: 14px;
  font-weight: 600;
}

/* Primary action */
.button-login {
  height: 50px;
  margin-top: 12px;
  --border-radius: 10px;
  --box-shadow: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Secondary actions (create account, go back): outlined, same size */
.button-account,
.button-go-back {
  height: 50px;
  margin-top: 10px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;
  border-radius: 10px !important;
  --border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background-color 0.15s ease;
}
.button-account:hover,
.button-go-back:hover {
  background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/_auth-polish.scss","webpack://./src/components/form-components/form-create-account/form-create-account.component.scss"],"names":[],"mappings":"AAAA;;;iDAAA;AAyEA,4EAAA;ACvEA;EACE,cAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA,+DAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAIF;AAFE;EACE,sBAAA;EACA,oBAAA;AAIJ;;AAAA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;;AAAA;;EAEE,aAAA;EACA,gBAAA;AAGF;;AAAA;EACE,2BAAA;EACA,qCAAA;EACA,kBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AAGF;;AAAA;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qDAAA;AAGF;;AAAA;EACE,0CAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;AAGF;AADE;EACE,YAAA;AAGJ;;AACA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,+BAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,+BAAA;AAEF;;AACA;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,sBAAA;AAEF;;AACA,qDAAA;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,0CAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AAEF;;AACA,6CAAA;AACA;EACE,+BAAA;EACA,gBAAA;EACA,eAAA;AAEF;AAAE;EACE,qCAAA;AAEJ;;AAEA,uFAAA;ADvJE,iFAAA;AACA;;EAEE,qBAAA;EACA,sDAAA;EACA,mDAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;ACyJJ;;ADtJE,qCAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACyJJ;;ADtJE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;ACyJJ;;ADtJE,yDAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;ACyJJ;;ADtJE;EACE,eAAA;EACA,gBAAA;ACyJJ;;ADtJE,mBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;ACyJJ;;ADtJE,qEAAA;AACA;;EAEE,YAAA;EACA,gBAAA;EACA,oEAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;ACyJJ;ADvJI;;EACE,qEAAA;AC0JN","sourcesContent":["/* Light polish of the access forms (login, password reset/request, account creation) that keeps\n * their original layout: outlined fields like the other forms, more breathing room\n * and clearer buttons. Use it with @include auth-polish.form; at the END of the form\n * stylesheet, so it wins over the older rules. */\n\n@mixin form {\n  /* Fields: outlined and rounded like the other forms, primary ring when focused */\n  ion-input[fill=\"outline\"],\n  ion-select[fill=\"outline\"] {\n    --border-radius: 10px;\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.4);\n    --highlight-color-focused: var(--ion-color-primary);\n    --background: var(--ion-background-color, #fff);\n    min-height: 56px;\n    margin-bottom: 14px;\n  }\n\n  /* Title / description of the forms */\n  .titleLbl {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .descriptionlbl {\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n    color: var(--ion-color-medium-shade);\n  }\n\n  /* \"Forgot password?\": on the right, under the password */\n  ion-item:has(.label-forgot-password) {\n    --background: transparent;\n    --padding-start: 0;\n    --inner-padding-end: 0;\n    margin-top: -6px;\n    text-align: right;\n  }\n\n  .label-forgot-password {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  /* Primary action */\n  .button-login {\n    height: 50px;\n    margin-top: 12px;\n    --border-radius: 10px;\n    --box-shadow: none;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  /* Secondary actions (create account, go back): outlined, same size */\n  .button-account,\n  .button-go-back {\n    height: 50px;\n    margin-top: 10px;\n    border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;\n    border-radius: 10px !important;\n    --border-radius: 10px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;\n    }\n  }\n}\n\n/* Page around the forms: slightly narrower column and a more compact logo */\n@mixin page {\n  .content-login {\n    width: min(100%, 520px);\n  }\n\n  .container-logo-login img {\n    max-height: 180px;\n    margin-block-end: 32px;\n  }\n}\n","@use \"../../../theme/auth-polish\";\n\nion-checkbox {\n  margin-left: 0;\n}\n\nion-button {\n  width: 100%;\n}\n\n.iconTab {\n  height: 15px;\n  font-size: 16px;\n  transform: scale(2);\n}\n\n.centerCol {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\nion-checkbox {\n  margin-right: 15px;\n}\n\n/* Consents: checkbox aligned with the first line of its text */\nion-item:has(.label-term-of-condition) {\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --background: transparent;\n  --min-height: 0;\n  margin-top: 10px;\n\n  ion-checkbox {\n    align-self: flex-start;\n    margin: 2px 12px 0 0;\n  }\n}\n\n.label-term-of-condition {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: normal;\n  color: var(--ion-color-medium-shade);\n}\n\n.item-remember-me {\n  margin-top: 9px;\n}\n\n.item-auto-access {\n  margin-bottom: 9px;\n}\n\n.checkbox-in-list,\n.checkbox-label {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.item-checkbox {\n  --ripple-color: transparent;\n  --background-hover: var(--background);\n  --min-height: 35px;\n}\n\n.button-login {\n  --box-shadow: none;\n  --border-radius: 10px;\n  font-size: 17px;\n}\n\n.button-account {\n  --box-shadow: none;\n  --background: white;\n  color: var(--ion-color-primary);\n  border: 1px solid var(--ion-color-primary) !important;\n}\n\n.divRole {\n  background-color: var(--ion-color-primary);\n  color: white;\n  width: 100%;\n  border-radius: 10px;\n  cursor: hand;\n  cursor: pointer;\n  border: 2px solid var(--ion-color-primary);\n\n  ion-icon {\n    color: white;\n  }\n}\n\n.divRoleNotSelected {\n  background-color: white;\n  border-radius: 10px;\n  width: 100%;\n  color: var(--ion-color-primary);\n  border: 2px solid var(--ion-color-primary);\n  cursor: hand;\n  cursor: pointer;\n}\n\n.gridRole {\n  padding: 15px 15px;\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n}\n\n.roleItem {\n  margin-top: 5px;\n  /* Role cards as wide as the fields below */\n  --padding-start: 0;\n  --inner-padding-end: 0;\n}\n\n/* Space between the role cards and the first field */\n.roleItem + ion-input {\n  margin-top: 22px;\n}\n\n.labelRole {\n  margin-left: 5px;\n}\n\n.labelDescription {\n  font-size: 10px;\n  margin-left: 5px;\n}\n\n.label-floating-login {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.button-go-back {\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 10px;\n  color: var(--ion-color-primary);\n  font-size: 17px;\n}\n\n/* Links to the privacy policy / conditions */\na {\n  color: var(--ion-color-primary);\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ion-color-primary-shade);\n  }\n}\n\n/* Light polish keeping the original look (kept last so it wins over the rules above) */\n@include auth-polish.form;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
